import { Spin } from 'antd';
import { ArrowRight } from 'assets/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useArticles } from 'apis/query';
import styles from './Spotlight.module.css';

const itemPerPage = 1;

export default function Spotlight({
  category = 'blog',
  title = 'Lorem Ipsum',
}) {
  const navigate = useNavigate();

  const {
    items = [],
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useArticles({
    limit: itemPerPage,
    type: 'spotlight',
    category,
  });

  const spotlightPresent = items?.some((data) => data.type === 'spotlight');

  return (
    spotlightPresent && (
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          size="large"
        >
          <div className={styles.content}>
            {items?.map((item, index) => (
              <div key={index} className={styles.spotlightItem}>
                <div className={styles.imageContainer}>
                  <img
                    loading="lazy"
                    alt="spotlight"
                    src={item.image}
                    className={styles.image}
                  />
                </div>
                <div className={styles.textContainer}>
                  <div className={styles.textHeader}>
                    <div className={styles.itemTitle}>{item.title}</div>
                    {(item.author || item.date) && (
                      <div className={styles.itemMeta}>
                        <b>{item.author}</b> · {item.date}
                      </div>
                    )}
                    <div className={styles.itemDescription}>
                      {item.description}
                    </div>
                  </div>
                  <div className={styles.readMoreContainer}>
                    <button
                      onClick={() =>
                        navigate(`/${category}/detail/${item?.slug}`, {
                          state: { data: item },
                        })
                      }
                      className={styles.button}
                    >
                      Read More <ArrowRight fill="#fff" />
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {hasNextPage && (
              <div className={styles.loadMoreContainer}>
                <button
                  onClick={() => fetchNextPage()}
                  className={styles.button}
                >
                  Load More
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    )
  );
}
